export default {
  menu: '偏好管理',
  title: {
    list: '问卷列表',
    edit: '编辑问卷',
    survey: {
      employee: '员工问卷',
      candidate: '求职者问卷'
    }
  },
  label: {
    name: '目标用户',
    question: {
      cn: '中文问题',
      en: '英文问题'
    },
    answerType: '回答类型',
    optionType: '问题选项类型',
    optionTypeTip: '请注意，部分问题和职位提醒机制相关。该机制允许当偏好匹配时，自动提醒候选人相关的新职位发布。',
    customOptions: {
      cn: '中文自定义选项',
      en: '英文自定义选项'
    },
    disabled: '（已禁用）'
  },
  surveyType: {
    employee: '员工问卷',
    candidate: '求职者问卷'
  },
  answerType: {
    single: '单选',
    multiple: '多选'
  },
  optionType: {
    custom: '自定义',
    tag: '职位标签',
    city: '职位城市（和职位提醒机制相关）',
    role_type: '职位性质（和职位提醒机制相关）',
    job_type: '职位类型（和职位提醒机制相关）',
    suffix: '（和职位提醒机制相关）'
  },
  upload: {
    pc: {
      tip: '添加电脑端图片',
      subTip: '推荐大小为：1100*370且小于5MB'
    },
    mobile: {
      tip: '添加手机端图片',
      subTip: '推荐大小为：750*450且小于5MB'
    }
  },
  btn: {
    addQuestion: {
      select: '添加选择题',
      text: '添加问答题'
    },
    editQuestion: {
      select: '编辑选择题',
      text: '编辑问答题'
    }
  },
  message: {
    imageRequired: '请添加手机端和电脑端图片',
    questionRequired: '请至少添加一个问题',
    questionNameRequired: '该字段不能为空。',
    questionTypeRequired: '请选择回答类型',
    optionTypeRequired: '请选择选项类型',
    customOptionsRequired: '该字段不能为空。',
    customOptionsNeedSameLine: '中英文自定义选项行数必须相同',
    wrongImageType: '请上传图片文件！',
    wrongImageSize: '请上传小于{size}MB的文件！',
    uploadError: '上传失败，请稍后再试'
  }
}
